import * as PromotionModal from '../Promotion Modal/PromotionModal';
import * as bannerService from '/source/js/services/bannerService';

function initSitewidePromotionBannerSlider() {
    let productsToCheck = [];
    let $sitewidePromotionBannerScroll = $('.site-promotion-banner__slider');
    let $slides = $('.site-promotion-banner__slide');
    $slides.each(function (key, slide) {
        var alwaysDisplay = $(slide).attr('data-banner-alwaysdisplay');
        var isCheckStock = $(slide).attr('data-banner-checkstock');
        var productIds = $(slide).attr('data-banner-checkproduct');
        if(alwaysDisplay === 'false' && isCheckStock === 'true' && productIds) {
            productsToCheck = productIds.split(',');
            checkStock(key, productsToCheck);
        }
    });

    if($sitewidePromotionBannerScroll.length < 1) return;

    $sitewidePromotionBannerScroll.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false
    });
}

function showPromotionBannerModal() {
    let refId = $(this).attr('data-referenceId');
    PromotionModal.bindModal(refId);
}

async function checkStock(key, productsToCheck) {
    console.log('productsToCheck: ', productsToCheck);
    if(productsToCheck && productsToCheck.length > 0 && productsToCheck.some(i => i)) {
        let response = await bannerService.checkStock(productsToCheck);
        if(response && response.length > 0) {
            console.log('Response', response);
            if(response.length === productsToCheck.length) {
                $('.site-promotion-banner__slider').slick('slickRemove', key);
            }
        }
    }
}

$(function () {
    initSitewidePromotionBannerSlider();
    $('.site-promotion-banner__modal-link').on('click', showPromotionBannerModal);
});
